// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.toast {
  position: fixed;
  top: 20px;
  right: 20px;
  min-width: 300px;
  max-width: 400px;
  padding: 16px 20px;
  border-radius: 12px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.4);
  z-index: 10000;
  animation: slideIn 0.3s ease-out;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

@keyframes slideIn {
  from {
    transform: translateX(100%);
    opacity: 0;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
}

.toast-success {
  background: linear-gradient(135deg, #10B981 0%, #059669 100%);
  border: 1px solid rgba(16, 185, 129, 0.3);
}

.toast-error {
  background: linear-gradient(135deg, #EF4444 0%, #DC2626 100%);
  border: 1px solid rgba(239, 68, 68, 0.3);
}

.toast-info {
  background: linear-gradient(135deg, #3B82F6 0%, #2563EB 100%);
  border: 1px solid rgba(59, 130, 246, 0.3);
}

.toast-content {
  display: flex;
  align-items: center;
  gap: 12px;
  flex: 1 1;
}

.toast-icon {
  font-size: 20px;
  font-weight: bold;
  color: white;
}

.toast-message {
  color: white;
  font-size: 14px;
  font-weight: 500;
  line-height: 1.4;
}

.toast-close {
  background: rgba(255, 255, 255, 0.2);
  border: none;
  color: white;
  font-size: 20px;
  cursor: pointer;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.2s;
  flex-shrink: 0;
}

.toast-close:hover {
  background: rgba(255, 255, 255, 0.3);
}



`, "",{"version":3,"sources":["webpack://./src/components/Toast.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,SAAS;EACT,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,yCAAyC;EACzC,cAAc;EACd,gCAAgC;EAChC,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE;IACE,2BAA2B;IAC3B,UAAU;EACZ;EACA;IACE,wBAAwB;IACxB,UAAU;EACZ;AACF;;AAEA;EACE,6DAA6D;EAC7D,yCAAyC;AAC3C;;AAEA;EACE,6DAA6D;EAC7D,wCAAwC;AAC1C;;AAEA;EACE,6DAA6D;EAC7D,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,SAAO;AACT;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;EACpC,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,eAAe;EACf,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,2BAA2B;EAC3B,cAAc;AAChB;;AAEA;EACE,oCAAoC;AACtC","sourcesContent":[".toast {\n  position: fixed;\n  top: 20px;\n  right: 20px;\n  min-width: 300px;\n  max-width: 400px;\n  padding: 16px 20px;\n  border-radius: 12px;\n  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.4);\n  z-index: 10000;\n  animation: slideIn 0.3s ease-out;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n}\n\n@keyframes slideIn {\n  from {\n    transform: translateX(100%);\n    opacity: 0;\n  }\n  to {\n    transform: translateX(0);\n    opacity: 1;\n  }\n}\n\n.toast-success {\n  background: linear-gradient(135deg, #10B981 0%, #059669 100%);\n  border: 1px solid rgba(16, 185, 129, 0.3);\n}\n\n.toast-error {\n  background: linear-gradient(135deg, #EF4444 0%, #DC2626 100%);\n  border: 1px solid rgba(239, 68, 68, 0.3);\n}\n\n.toast-info {\n  background: linear-gradient(135deg, #3B82F6 0%, #2563EB 100%);\n  border: 1px solid rgba(59, 130, 246, 0.3);\n}\n\n.toast-content {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  flex: 1;\n}\n\n.toast-icon {\n  font-size: 20px;\n  font-weight: bold;\n  color: white;\n}\n\n.toast-message {\n  color: white;\n  font-size: 14px;\n  font-weight: 500;\n  line-height: 1.4;\n}\n\n.toast-close {\n  background: rgba(255, 255, 255, 0.2);\n  border: none;\n  color: white;\n  font-size: 20px;\n  cursor: pointer;\n  width: 24px;\n  height: 24px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: background 0.2s;\n  flex-shrink: 0;\n}\n\n.toast-close:hover {\n  background: rgba(255, 255, 255, 0.3);\n}\n\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
